import { useState } from "react";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";

const OnlineConsultBanner = ({ language, setLanguage }) => {
  

  const toggleLanguage = () => {
    setLanguage(prev => (prev === "hindi" ? "english" : "hindi"));
  };

  return (
    <div className="w-full fixed top-0 bg-[#f9f5ec] text-black py-4 px-4 sm:px-6 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-6 shadow-md   z-50 border border-gray-900">
      <p className="text-base sm:text-lg font-medium text-center flex-1 animate-pulse">
        {language === "hindi" ? (
          <>
            📲 <span className="text-orange-500 underline underline-offset-4">व्हाट्सएप</span> और <span className="text-orange-500 underline underline-offset-4">ईमेल</span> के माध्यम से ऑनलाइन ज्योतिष परामर्श प्राप्त करें – कभी भी, कहीं भी!
          </>
        ) : (
          <>
            📲 Get Online Astrology Consultation via <span className="text-orange-500 underline underline-offset-4">WhatsApp</span> & <span className="text-orange-500 underline underline-offset-4">Email</span> – Anytime, Anywhere!
          </>
        )}
      </p>

      <div className="flex items-center justify-center gap-4 text-xl">
        <a
          href="https://wa.me/9827504751?text=🔮✨ *नमस्ते आचार्य जी*, मैं आपकी ज्योतिषीय सेवाओं का लाभ उठाना चाहता हूँ और मार्गदर्शन प्राप्त करना चाहता हूँ। कृपया मेरी सहायता करें। 🙏"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:scale-110 transition-transform"
        >
          <FaWhatsapp className="text-green-600" />
        </a>
        <a
          href="mailto:astromahamaya@gmail.com"
          className="hover:scale-110 transition-transform"
        >
          <FaEnvelope className="text-black" />
        </a>
        <button
          onClick={toggleLanguage}
          className="text-xs border border-black rounded px-2 py-1 hover:bg-black hover:text-white transition-colors"
        >
          {language === "hindi" ? "EN" : "हिंदी"}
        </button>
      </div>
    </div>
  );
};

export default OnlineConsultBanner;
